export default {
  companyArr: [
    {
      title: '京东健康股份有限公司',
      desc: '创新打造在线上线下一体化医疗健康服务生态，提升并开放自身生态能力，帮助产业上中下游实体企业和业态转型升级，助推我国数字经济和实体经济深度融合发展。'
    },
    {
      title: '赛诺菲（中国）投资有限公司',
      desc: '致力于更快、更有效地满足中国亟待解决的医疗需求，引进创新药品和疫苗40余种，通过缩短药品审批进程将全球创新药物带给中国患者。'
    },
    {
      title: '阿斯利康制药有限公司',
      desc: '不断深耕本土业务，积极携手本土创新力量打造医疗健康创新生态圈。借力中国优越营商环境，协力跨界合作伙伴突破创新边界，助力中国医疗健康产业和经济蓬勃发展。'
    },
    {
      title: '葛兰素史克（中国）投资有限公司',
      desc: '肩负特殊使命、以科学为导向，引进一系列创新疫苗和药物，以核心创新能力助力中国公共卫生事业建设。'
    },
    {
      title: '北京诺华制药有限公司',
      desc: '为中国患者提供突破性创新药物，并增加药物可及性，寻找新途径，持续为更多患者提供高品质、可负担的健康服务。'
    },
    {
      title: '雀巢健康科学（中国）有限公司',
      desc: '创新开发中国特色特医食品配方，让更多患者获得营养治疗，缓解临床营养治疗缺口，大力推动中国特医食品行业创新发展。'
    },
    {
      title: '施维雅（天津）制药有限公司',
      desc: '聚焦中国需求巨大的慢病领域和难治性肿瘤，坚持以解决患者诉求为核心进行产品创新研发，发挥数字化优势不断推进药物可及到药物普及。'
    },
    {
      title: '杭州诺辉健康科技有限公司',
      desc: '中国癌症居家筛查市场的开创者和领跑者，专注于高发癌症居家早筛，推进癌症筛查技术的创新，加速癌症筛查技术在中国的普及。'
    },
    {
      title: '美年大健康产业控股股份有限公司',
      desc: '作为预防医学头部企业，美年健康坚持创新引领，打造“全方位全生命周期的数字化健康服务平台”'
    }
  ],
  personFArr: [
    {
      name: '徐兵河',
      title: '中国工程院院士、肿瘤内科专家',
      desc: '创新提升患者生命质量'
    },
    {
      name: '刘国恩',
      title:
        '北京大学全球健康发展研究院院长、北京大学国家发展研究院博雅特聘教授',
      desc: '从卫生经济学角度看药物创新'
    },
    {
      name: '史录文',
      title:
        '北京大学药学院药事管理与临床药学系博士研究生导师、北京大学医药管理国际研究中心主任、北京大学国家药品医疗器械监管科学研究院副院长',
      desc: '制度创新 让患者用上优价好药'
    },
    {
      name: '梁晓峰',
      title:
        '中华预防医学会兼职副会长、暨南大学疾病预防控制研究院院长、暨南大学疫苗产业研究院院长、中国疾控中心原副主任',
      desc: '疫苗研发创新先行 共筑健康屏障 共筑健康屏障'
    },
    {
      name: '马军',
      title: '哈尔滨血液病肿瘤研究所所长',
      desc: '创新助力健康中国 造福中国患者'
    },
    {
      name: '王杰军',
      title: '国家卫生健康委员会肿瘤合理用药专家委员会副主任委员',
      desc: '创新成果 守护肿瘤患者生存质量'
    },
    {
      name: '钟文昭',
      title: '广东省肺癌研究所所长、广东省人民医院肺外科主任医师',
      desc: '中国肺癌创新治疗与世界水平接轨'
    },
    {
      name: '顾欣鑫',
      title: '雀巢健康科学大中华区总裁',
      desc: '聚力创新 特医食品赋能肿瘤患者生存治疗'
    },
    {
      name: '李燕',
      title: '中国医药创新促进会会长',
      desc: '行业内卷下的中国医药创新之路'
    },
    {
      name: '彭振科',
      title: 'RDPAC执行主席、辉瑞生物制药集团中国区总裁',
      desc: '跨国药企助力中国创新'
    },
    {
      name: '王磊',
      title: '阿斯利康全球执行副总裁，国际业务及中国总裁',
      desc: '以患者为中心 源源不断带来创新成果守护人民健康'
    },
    {
      name: '朱叶青',
      title: '诺辉健康CEO',
      desc: '守正出奇 癌症早筛行业的创新之路'
    },
    {
      name: '俞熔',
      title: '美年健康董事长',
      desc: '做健康预防事业的“领跑者”'
    }
  ]
}
